module.exports = __webpack_public_path__ + "img/menu-prevention.26ec3050.svg";